// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"dee371c2","300":"c626d805","458":"5d59a592","540":"0c82b0f7","895":"f1c8e290","901":"1c7e20fa","949":"2e5c7447"}[chunkId] + ".chunk.js";
};